import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex bg-white border-b h-18" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "relative flex justify-center flex-1 overflow-hidden" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute top-0 left-0 z-40 w-10 h-full",
  style: {"background":"linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)"}
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute top-0 right-0 z-40 w-10 h-full",
  style: {"background":"linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)"}
}, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "relative flex items-center justify-center h-2 mt-2"
}
const _hoisted_7 = { class: "flex flex-col text-left" }
const _hoisted_8 = { class: "flex flex-col py-3 border-t border-gray-100" }
const _hoisted_9 = { class: "break-words text-gray-400" }
const _hoisted_10 = { class: "break-words text-gray-900 mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_HorizontalScroll = _resolveComponent("HorizontalScroll")!
  const _component_portal_target = _resolveComponent("portal-target")!
  const _component_PatientDetailsCard = _resolveComponent("PatientDetailsCard")!
  const _component_NavDropdown = _resolveComponent("NavDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      "data-dusk": "workflow-close-btn",
      class: _normalizeClass(["flex items-center justify-center text-gray-900 w-18 focus:outline-none group border-r", _ctx.disabled ? 'text-gray-300 cursor-not-allowed' : 'text-gray-900']),
      disabled: _ctx.disabled,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
    }, [
      _createVNode(_component_BaseIcon, {
        name: "close",
        class: _normalizeClass(["text-2xl stroke-1.5", {
          'transform duration-150 group-hover:scale-110 group-focus:scale-110': !_ctx.disabled
        }])
      }, null, 8, ["class"])
    ], 10, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      (_ctx.steps.length > 1)
        ? (_openBlock(), _createBlock(_component_HorizontalScroll, {
            key: 0,
            ref: "scrollContainer",
            class: "flex h-full select-none scrollbars-hidden",
            onMouseleave: _ctx.centerCurrentStep
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "flex items-center"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass({
              'pl-5': index === _ctx.firstIndex,
              'pr-5': index === _ctx.steps.length - 1
            })
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["px-5 text-sm font-semibold whitespace-no-wrap", {
                'text-success-500': index < _ctx.currentStep,
                'text-gray-900': index === _ctx.currentStep,
                'text-gray-400': index > _ctx.currentStep
              }])
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass({
                  'bg-gray-200 text-transparent h-3 rounded-lg': _ctx.loading
                })
                      }, _toDisplayString(step), 3)
                    ], 2),
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (index !== _ctx.firstIndex)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["absolute left-0 w-1/2 border-t-2", index <= _ctx.currentStep ? 'border-success-500' : 'border-gray-300'])
                              }, null, 2))
                            : _createCommentVNode("", true),
                          (index !== _ctx.steps.length - 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["absolute right-0 w-1/2 border-t-2", index < _ctx.currentStep ? 'border-success-500' : 'border-gray-300'])
                              }, null, 2))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["absolute w-2 h-2 rounded-full", {
                  'bg-success-500': index < _ctx.currentStep,
                  'bg-white border-2 border-success-500': index === _ctx.currentStep,
                  'bg-gray-300': index > _ctx.currentStep
                }])
                          }, null, 2)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ])), [
                  [_vShow, step]
                ])
              }), 128))
            ]),
            _: 1
          }, 8, ["onMouseleave"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_portal_target, { name: "triage" }),
    (_ctx.patient)
      ? (_openBlock(), _createBlock(_component_NavDropdown, {
          key: 0,
          class: "border-l",
          scrollable: false,
          disabled: _ctx.loading
        }, {
          button: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", {
                style: {"max-width":"max-content"},
                class: _normalizeClass(_ctx.loading ? 'bg-gray-200 text-transparent rounded-lg h-3' : 'font-medium text-sm text-gray-900')
              }, _toDisplayString(_ctx.patient.last_name) + ", " + _toDisplayString(_ctx.patient.first_name), 3),
              _createElementVNode("span", {
                style: {"max-width":"max-content"},
                class: _normalizeClass(
              _ctx.loading ? 'bg-gray-200 text-transparent rounded-lg h-3' : 'text-sm font-medium uppercase text-gray-600'
            )
              }, " ID: " + _toDisplayString(_ctx.patient.mrn), 3)
            ])
          ]),
          menu: _withCtx(() => [
            _createVNode(_component_PatientDetailsCard, {
              id: _ctx.patient.mrn,
              class: "w-72 -m-2 z-20",
              "first-name": _ctx.$t('platform.patient.details'),
              "show-initials": false,
              infos: _ctx.patientInfos,
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('platform.common.address')), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.patient.address && _ctx.patient.address.formatted_address ? _ctx.patient.address.formatted_address : null), 1)
                ])
              ]),
              _: 1
            }, 8, ["id", "first-name", "infos", "loading"])
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}